import { motion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headings
export const MaskLines = ({ lines, className = "", lineClassName = "", start = 0.1, stagger = 0.12 }) => (
  <span className="block">
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: start + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
    <span className={className} />
  </span>
);
